/** Nudge a just-opened absolutely-positioned dropdown menu back onto
 *  the viewport when its default anchor (`right: 0` on a parent
 *  near the left edge of the screen, for instance) would push it
 *  partially off-screen.
 *
 *  Assumes the menu uses `position: absolute` with `right: 0` in
 *  base CSS, which anchors it to the trigger button's right edge.
 *  On buttons near the left screen edge this puts the menu's left
 *  edge in negative territory; we set an inline `right: <negative>`
 *  that shifts the menu rightward until its left edge lands at
 *  `MARGIN` from the viewport. The mirror case (button near the
 *  right edge and menu wider than the button) shifts the menu left.
 *
 *  Callers must add the `.open` class (or otherwise cause the menu
 *  to render) BEFORE calling — `getBoundingClientRect` returns
 *  zeros for `display: none` elements.
 *
 *  Used by the deck-builder collection filter menus and the auction
 *  house filter menus. Any future absolutely-positioned dropdown of
 *  the same shape can reuse this. */
export function positionDropdown(menuEl: HTMLElement): void {
  menuEl.style.right = '';
  const rect = menuEl.getBoundingClientRect();
  const MARGIN = 8;
  if (rect.left < MARGIN) {
    menuEl.style.right = `${rect.left - MARGIN}px`;
  } else if (rect.right > window.innerWidth - MARGIN) {
    menuEl.style.right = `${rect.right - (window.innerWidth - MARGIN)}px`;
  }
}
